// Modifier retry configuration
// For each modifier, specify the percentage decrease per retry for each variable.
// Set to 0 for no change.

const MODIFIER_RETRY_CONFIG = {
  retryMaxCount: 10, // Global max retry count for all modifiers
  displacement: {
    strength: 30,      // Decrease by 30% per retry
    noiseScale: 30,      // Decrease by 30% per retry
    translation: 0     // No change
  },
  twist: {
    angle: 30          // Decrease by 30% per retry
  },
  radial_wave: {
    strength: 30,      // Decrease by 30% per retry
    wavesPerRevolution: 0 // No change
  },
  radial_wrinkle: {
    strength: 30,      // Decrease by 30% per retry
    perimeter: 30       // Decrease by 30% per retry
  },
  facet: {
    facetCount: 0,     // No change
    facetDepth: 30,    // Decrease by 30% per retry
    facetBlend: 0      // No change
  },
  layer: {
    layer_count: 30,     // Decrease by 30% per retry
    amplitude: 30,     // Decrease by 30% per retry
    bunchiness: 0      // No change
  }
};

export default MODIFIER_RETRY_CONFIG; 